import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const addAiGeneratedQuestionAction = createAsyncThunk(
    'Add-Ai-generated-question',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/add-ai-question-answer`,data.selectedQuestion )
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const addAiGeneratedQuestionSlice = createSlice({
    name: 'Add-Ai-generated-question',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(addAiGeneratedQuestionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(addAiGeneratedQuestionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(addAiGeneratedQuestionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const addAiGeneratedQuestionReducer = addAiGeneratedQuestionSlice.reducer